import { Component } from "@angular/core";

@Component({
    selector: 'payout-format',
    templateUrl: 'payout-format.html'
})
export class PayoutFormatPage {
    
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/settings/payout-format/payout-format.ts